import React from 'react';

import { Snackbar, SnackbarCloseReason } from '@mui/material';
import { toastState } from '../../state/RecoilState';
import { useRecoilState } from 'recoil';

const Toast: React.FC = () => {
  const [toast, setToast] = useRecoilState(toastState);

  const handleCloseSnackbar = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setToast(undefined);
  };
  return (
    <Snackbar
      open={!!toast}
      autoHideDuration={2000}
      message={toast}
      onClose={handleCloseSnackbar}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    />
  );
};
export default Toast;
